import * as z from 'zod';

export const lastNameSchema = z
  .string()
  .nonempty({ message: '必須項目です。' });

export const firstNameSchema = z
  .string()
  .nonempty({ message: '必須項目です。' });
